<!--===============================
=            PORTFOLIO            =
================================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Portfolio</div>
      </base-header>
    </v-row>
    <card-slider></card-slider>
    <v-row>
      <template>
       
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

              Portfolio
            </div> <div slot="card-subheader">Trade bot using artificial intelligence to make money</div>
            <div slot="card-body">
         <echarts-polar-bar></echarts-polar-bar>
            </div>
          </base-card>
        </v-col>
     <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

             Wallet to Mounth
            </div> <div slot="card-subheader">Trade bot using artificial intelligence to make money</div>
            <div slot="card-body">
              <v-list class="transparent" dark subheader>
                <v-subheader>Recent chat</v-subheader>

                <v-list-item v-for="chat in recent" :key="chat.title">
                  <v-list-item-avatar>
                    <v-img :alt="`${chat.title} avatar`" :src="require(`../../assets/images/coin/${chat.avatar}.png`)"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="chat.title"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon :color="chat.active ? 'primary accent-4' : 'red'">
                     {{chat.icon}}
                    </v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </div>
          </base-card>
        </v-col>
        
        <v-col cols="12" md="2" sm="12" v-for="x in updown" :key="x.id">
          <base-card>
            <div slot="card-header">
              <div class="text-center">
                <v-avatar tile class="rounded-lg elevation-10 mb-2" size="60" :color="x.color">
                  <v-icon size="40" dark>
                    {{x.icon}}
                  </v-icon>
                </v-avatar>
              </div>
            </div>
            <div slot="card-subheader">
              <div class="mt-3 text-center font-weight-black text-h5 white--text">{{x.number}}</div>
            </div>
            <div slot="card-body">
              <p class="text-center font-weight-black mt-n3 subtitle-1 text-uppercase white--text">
                {{x.coin}}
              </p>
            </div>
          </base-card>
        </v-col>
       
        
       
      </template>
    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  import EchartsPolarBar from '../../components/Charts/EchartsPolarBar'
  import CardSlider from '../../components/Cards/CardSlider'
  export default {
    components: {
      BaseCard,
      BaseHeader,EchartsPolarBar,CardSlider
    },
    data: () => ({
      recent: [{
          active: true,
          avatar: 'bnb',
          title: 'BNB',
          icon:'north'
        },
        {
          active: true,
          avatar: 'ada',
          title: 'Mike Carlson', icon:'north'
        },
        { active: true,
          avatar: 'link',
          title: 'Cindy Baker', icon:'north'
        },
        {
          avatar: 'sxp',
          title: 'SXP', icon:'south'
        },  {
          active: true,
          avatar: 'bat',
          title: 'BAT', icon:'north'
        },
        { active: true,
          avatar: 'solana',
          title: 'SOL', icon:'north'
        },
      ],
      updown: [{
        id: '1',
        color: 'green',
        icon: 'file_upload',
        number: '54%',
        coin: 'BTCUSDT'
      }, {
        id: '2',
        color: 'red',
        icon: 'file_download',
        number: '5%',
        coin: 'ZILUSDT'
      }, {
        id: '3',
        color: 'green',
        icon: 'file_upload',
        number: '+4%',
        coin: 'MBLUSDT'
      }, {
        id: '4',
        color: 'red',
        icon: 'file_download',
        number: '-15%',
        coin: 'BATUSDT'
      }, {
        id: '5',
        color: 'green',
        icon: 'file_upload',
        number: '+8%',
        coin: 'BRLUSDT'
      }, {
        id: '6',
        color: 'red',
        icon: 'file_download',
        number: '-5%',
        coin: 'BNBUSDT'
      }],
      previous: [{
        title: 'Travis Howard',
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
      }],
    }),

  }
</script>

<!--====  End of PORTFOLIO  ====-->
